"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isColorInPreset = exports.ColorPickerPresets = exports.ColorGridPreset = void 0;
var tableau_ui_1 = require("@tableau/tableau-ui");
var Localize_1 = require("../../../gen-src/Localize");
var ColorGridPreset;
(function (ColorGridPreset) {
    ColorGridPreset[ColorGridPreset["Dark"] = 0] = "Dark";
    ColorGridPreset[ColorGridPreset["Light"] = 1] = "Light";
    ColorGridPreset[ColorGridPreset["MaestroFlowColors"] = 2] = "MaestroFlowColors";
})(ColorGridPreset = exports.ColorGridPreset || (exports.ColorGridPreset = {}));
exports.ColorPickerPresets = (_a = {},
    _a[ColorGridPreset.Dark] = { palette: tableau_ui_1.DarksPalette, label: Localize_1.Messages.colorsDark },
    _a[ColorGridPreset.Light] = { palette: tableau_ui_1.LightsPalette, label: Localize_1.Messages.colorsLight },
    _a[ColorGridPreset.MaestroFlowColors] = { palette: tableau_ui_1.FlowsPalette, label: Localize_1.Messages.colorsFlow },
    _a);
/**
 * @param color the hex value of the color to search for. Must be prefixed with a hash, e.g. `'#bfbfbf'`.
 * @param preset the palette to search.
 */
function isColorInPreset(color, preset) {
    return tableau_ui_1.isColorInPalette(color, exports.ColorPickerPresets[preset].palette);
}
exports.isColorInPreset = isColorInPreset;
//# sourceMappingURL=ColorPickerPresets.js.map